const initialState = {
  fetching: false,
  fetched: false,
  items: [],
  error: null,
  nbResult: 0,
};

export const surveyCampaignReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'INITIALIZE_SURVEY_CAMPAIGN': {
      return initialState;
    }
    case 'FETCH_SURVEY_CAMPAIGN_PENDING': {
      return { ...state, fetching: true };
    }
    case 'FETCH_SURVEY_CAMPAIGN_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        items: action.payload.data.data,
      };
    }
    case 'FETCH_SURVEY_CAMPAIGN_REJECTED': {
      let error = action.payload;
      switch (error.response?.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404,
          };
          break;
        default:
      }
      return {
        ...state,
        fetching: false,
        error,
        items: []
      };
    }
    default:
      return state;
  }
};
